export default __webpack_public_path__ + "static/media/pdf.6d848c28.svg";